import { useEffect, useMemo, useState } from 'react'
import ProductGrid from '../components/ProductGrid.jsx'
import { fetchProducts } from '../lib/products.js'
import './Catalog.css'

export default function Catalog() {
  const [products, setProducts] = useState([])
  const [loading, setLoading] = useState(true)
  const [sort, setSort] = useState('recommended')
  const [inStockOnly, setInStockOnly] = useState(false)

  useEffect(() => {
    let active = true
    fetchProducts()
      .then((data) => {
        if (active) setProducts(Array.isArray(data) ? data : [])
      })
      .catch((err) => {
        console.warn('Could not load products:', err)
        if (active) setProducts([])
      })
      .finally(() => {
        if (active) setLoading(false)
      })
    return () => {
      active = false
    }
  }, [])

  const visible = useMemo(() => {
    let list = [...products]
    if (inStockOnly) list = list.filter((p) => p.in_stock)

    // "Recommended" keeps the manual admin order exactly as fetched.
    if (sort === 'recommended') return list

    const within = {
      'price-asc': (a, b) => a.price - b.price,
      'price-desc': (a, b) => b.price - a.price,
      name: (a, b) => a.name.localeCompare(b.name),
    }[sort]

    list.sort((a, b) => {
      // In-stock products always come first, then apply the chosen sort.
      if (a.in_stock !== b.in_stock) return a.in_stock ? -1 : 1
      return within ? within(a, b) : 0
    })
    return list
  }, [products, sort, inStockOnly])

  return (
    <div className="catalog">
      <header className="catalog__hero deco-band">
        <div className="container">
          <span className="eyebrow">All products</span>
          <h1>Research compounds &amp; peptides</h1>
          <p>
            Every compound is third-party tested for verified purity. For
            research purposes only — not for human consumption.
          </p>
        </div>
      </header>

      <div className="container catalog__body">
        <div className="catalog__toolbar">
          <div className="catalog__controls">
            <label className="catalog__stock">
              <input
                type="checkbox"
                checked={inStockOnly}
                onChange={(e) => setInStockOnly(e.target.checked)}
              />
              In stock only
            </label>
            <select value={sort} onChange={(e) => setSort(e.target.value)}>
              <option value="recommended">Sort: Recommended</option>
              <option value="price-asc">Price: Low to High</option>
              <option value="price-desc">Price: High to Low</option>
              <option value="name">Name: A–Z</option>
            </select>
          </div>
        </div>

        {loading ? (
          <p className="grid__empty">Loading products…</p>
        ) : (
          <ProductGrid products={visible} />
        )}
      </div>
    </div>
  )
}
